<div [chart]="stock" style="height: 300px;"></div>